module.exports = __webpack_public_path__ + "img/5-1-IMG_3001.e7f3e4c0.png";